
<div class="images-section" #imagesSection>
    <div class="images-container">
        <div class="image-box i1">
            <img src="assets/images/reforestaction/deforestation_1.webp" />
        </div>
        <div class="image-box i2">
            <img src="assets/images/reforestaction/deforestation_2.webp" />
        </div>
        <div class="image-box i3">
            <img src="assets/images/reforestaction/deforestation_3.webp" />
        </div>
        <div class="image-box i4">
            <img src="assets/images/reforestaction/deforestation_4.webp" />
        </div>
        <div class="image-box i5">
            <img src="assets/images/reforestaction/deforestation_5.webp" />
        </div>
        <div class="image-box i6">
            <img src="assets/images/reforestaction/deforestation_6.webp" />
        </div>
        <div class="image-box i7">
            <img src="assets/images/reforestaction/deforestation_7.webp" />
        </div>
        <div class="image-box i8">
            <img src="assets/images/reforestaction/deforestation_8.webp" />
        </div>
    </div>
</div>
<div class="shadow-box" *ngIf="responsiveScreenService.isOrSmaller('m')"></div>

